import "./style.css";

export default function Features() {
	const features = [
		{
			icon: "poject based learning icon.svg",
			title: "Project Based Learning",
			description:
				"Master your craft through hands-on, project-based learning. Build a professional portfolio while solving actual industry challenges.",
		},
		{
			icon: "industry standard tools icon.svg",
			title: "Industry-Standard Tools",
			description:
				"Get hands-on with the same professional software and platforms used by experts. We bridge the gap between learning and employment.",
		},
		{
			icon: "daily skill learning icon.svg",
			title: "Daily Skill-Building",
			description:
				"Stay sharp with focused daily assignments. Consistent, manageable tasks ensure steady progress and long-term retention.",
		},
	];

	return (
		<section id="features" className="section-features">
			<img
				src="features-section-decoration.svg"
				alt="features-section-decoration"
				className="features__decoration"
			/>

			<div className="features__label">
				<img src="Illustration.svg" alt="" className="features__label__icon" />
				Our Features
			</div>

			<h2 className="features__heading features__heading-style">
				Why choose our courses?
			</h2>

			<div className="features__card__box">
				{features.map((feature, index) => (
					<div key={index} className="features__card">
						<div className="features__card__icon-box">
							<img src={feature.icon} alt="" className="features__card__icon" />
						</div>
						<h3 className="features__card__heading features__heading-style">
							{feature.title}
						</h3>
						<p className="features__card__desc">{feature.description}</p>
					</div>
				))}
			</div>
		</section>
	);
}
